import type { RouteLocationRaw } from 'vue-router'

export interface CurModalInfo {
  image: ImageSelection
  rightsType: string
  rights: LangString
  title: LangString
  source: LangString
  sourceUrl?: string
  link: string
  description: LangString
  data?: any
  type?: Key
  internalLink?: RouteLocationRaw | string
  ownerOrgId?: string
  id?: string
}

export const useCurationModal = () => {

  const imageSelection2ModalInfo = (image: ImageSelection): CurModalInfo => {
    return {
      image: image,
      title: image.title,
      description: image.description,
      link: image.sourceUrl,
      source: image.source,
      sourceUrl: image.sourceUrl,
      rights: image.contentsRights,
      rightsType: image.contentsRightsType,
      data: image['data'],
      internalLink: image['internalLink'],
      type: 'item',
    }
  }

  const itemAndImageSelection2ModalInfo = (item: Item, image: ImageSelection): CurModalInfo => {
    return {
      data: item,
      rightsType: image.contentsRightsType,
      image: image,
      rights: image.contentsRights,
      title: image.title,
      source: image.source,
      sourceUrl: image.sourceUrl,
      link: item.common.linkUrl,
      description: image.description,
      type: 'item',
      ownerOrgId: item.common.ownerOrg,
    }
  }

  return {
    imageSelection2ModalInfo,
    itemAndImageSelection2ModalInfo,
  }

}

